import React from "react";
import { useLocation } from "react-router-dom";
import patientIcon from "../../assets/patient.svg";
import patientGreenIcon from "../../assets/patient.svg";
import vitalIcon from "../../assets/vital.svg";
import vitalGreenIcon from "../../assets/vitalgreen.svg";
import medicalIcon from "../../assets/medical.svg";
import medicalGreenIcon from "../../assets/medicalgreen.svg";
import bookIcon from "../../assets/bookserviceicon2.svg.svg";
import bookGreenIcon from "../../assets/bookserviceicongreen.svg";
import slotIcon from "../../assets/slot.svg";
import slotGreenIcon from "../../assets/slotgreen.svg";

const StepHeader = () => {
  const location = useLocation();

  const steps = [
    {
      label: "Patient Details",
      shortLabel: "Patient",
      path: "/Patientregister",
      icon: patientIcon,
      greenIcon: patientGreenIcon,
      hasGreen: false,
    },
    // {
    //   label: "Vital Details",
    //   shortLabel: "Vitals",
    //   path: "/VitalDetails",
    //   icon: vitalIcon,
    //   greenIcon: vitalGreenIcon,
    //   hasGreen: true,
    // },
    // {
    //   label: "Medical History",
    //   shortLabel: "Medical",
    //   path: "/Medicalhistory",
    //   icon: medicalIcon,
    //   greenIcon: medicalGreenIcon,
    //   hasGreen: true,
    // },
      {
      label: "Select a Services",
      shortLabel: "Medical",
      path: "/BookServicescard",
     icon: bookIcon,
      greenIcon: bookGreenIcon,
      hasGreen: true,
    },
    
    {
      label: "Book Appointment",
      shortLabel: "Slots",
      path: "/SlotBooking",
      icon: slotIcon,
      greenIcon: slotGreenIcon,
      hasGreen: true,
    },
  ];

  const currentIndex = steps.findIndex(
    (step) => location.pathname === step.path
  );

  return (
    <div className="mb-6 md:mb-6 ">
      {/* Desktop and Tablet View */}
     
     
 <div className="hidden sm:flex items-center justify-between bg-[#004276] rounded-md px-4 md:px-6 py-3 md:py-3 text-xs md:text-sm font-medium">
  {steps.map((step, index) => {
    const isCurrent = index === currentIndex;
 const isActive = index <= currentIndex;
          const iconSrc =
            step.hasGreen && isActive ? step.greenIcon : step.icon;

    return (
      <React.Fragment key={index}>
        <div
          className={`flex items-center gap-2 px-4 py-2 rounded-full transition duration-300 `}
        >
          <div className="flex items-center gap-1 md:gap-2">
                <img
                  src={iconSrc}
                  alt={step.label}
                  className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0"
                />
                <span
                  className={`whitespace-nowrap ${
                    isActive ? "text-[#3cba84] font-semibold" : "text-white"
                  }`}
                >
                  <span className="hidden lg:inline">{step.label}</span>
                  <span className="lg:hidden">{step.shortLabel}</span>
                </span>
              </div>
          {/* <span
            className={`text-sm font-semibold ${
              isCurrent ? "text-[#004276]" : isActive ? "text-[#3cba84]" : "text-gray-500"
            }`}
          >
            {step.label}
          </span> */}
        </div>

        {index < steps.length - 1 && (
          <div className="flex-1 border-t-2 border-dashed border-gray-300 mx-2"></div>
        )}
      </React.Fragment>
    );
  })}
</div>

      {/* Mobile View */}
      <div className="sm:hidden bg-[#004276] rounded-md px-3 py-3">
        {/* Current Step Display */}
        <div className="flex items-center justify-center gap-2 mb-3">
          <img
            src={
              steps[currentIndex]?.hasGreen
                ? steps[currentIndex]?.greenIcon
                : steps[currentIndex]?.icon
            }
            alt={steps[currentIndex]?.label}
            className="w-5 h-5"
          />
          <span className="text-[#3cba84] font-semibold text-sm">
            {steps[currentIndex]?.label}
          </span>
        </div>

        {/* Progress Indicators */}
        <div className="flex items-center justify-center gap-2">
          {steps.map((_, index) => (
            <div
              key={index}
              className={`h-2 flex-1 rounded-full transition-colors duration-300 ${
                index <= currentIndex
                  ? "bg-[#3cba84]"
                  : "bg-white bg-opacity-30"
              }`}
            ></div>
          ))}
        </div>

        {/* Step Counter */}
        <div className="text-center mt-2">
          <span className="text-white text-xs opacity-75">
            Step {currentIndex + 1} of {steps.length}
          </span>
        </div>
      </div>
    </div>
  );
};

export default StepHeader;
